import { USERS_LIST_GROUPS_COLLAPSE_THRESHOLD } from '../../dashboard/constants';

import linkedGroupsUrl from './linkedGroups.html';

class LinkedGroupsCtrl {
  constructor(UserUtils, $scope, $timeout) {
    'ngInject';

    Object.assign(this, { UserUtils, $scope, $timeout });
  }

  toggle =
    (state) =>
    (trigger = true) => {
      this.shouldShowAll = state;
      if (trigger) {
        this.$timeout(() => {
          this.onCollapseChange?.();
          this.$scope.$emit('vsRepeatTrigger');
        });
      }
    };

  $onInit() {
    this.displayedItemsLimit = USERS_LIST_GROUPS_COLLAPSE_THRESHOLD;

    this.showAll = this.toggle(true);
    this.showLess = this.toggle(false);

    this.canEditGroup = this.UserUtils.canEditGroup.bind(this.UserUtils);
    this.showLess(false);
  }
}

export default {
  bindings: {
    src: '=',
    comma: '=?',
    shouldShowAll: '=isExpanded',
    onCollapseChange: '&?',
  },
  templateUrl: linkedGroupsUrl,
  controller: LinkedGroupsCtrl,
  controllerAs: 'ctrl',
};
